import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const ToolsWrapper = styled.div`
	display: flex;
	height: calc(100vh - 65px);
	margin-top: 65px;	
`;	

export const ToolsBody = styled.div`
	flex: 1;	
	background-color: ${Variables.colors.complementary};
	max-height: calc(100vh - 65px);
	overflow-y: auto;  
	margin-right: ${props => props.noSidebar ? 0 : '256px'};	
`;

export const ToolsContainer = styled.div`	
	width: 100%;	
	min-height: calc(100vh - 100px);
	height: auto;
	overflow-x: auto;
	overflow-y: hidden;
`;